@if (strategyLoading) {
  <div class="strategy-details-container">
    <skeleton-strategy-details></skeleton-strategy-details>
  </div>
} @else {
  <div class="page-container">
    <pdq-button class="button-go-back" icon="side_left_arrow" (onClick)="navigateBack()"></pdq-button>

    <div class="strategy-details-container">
      @if (strategyItem?.deprecated) {
        <pdq-banner
          variant="attention"
          [closable]="false"
          content="This strategy is deprecated — once you remove your bookmark you won't be able to add it back.">
        </pdq-banner>
      }
      <div class="strategy-header component">
        <div class="strategy-header-top">
          <h2>{{ strategyItem?.[strategyColumns.NAME] }}</h2>
        </div>
        <div class="strategy-header-tags">
          <p class="category" [ngClass]="[optimizeCategoryName(strategyItem)]">
            {{ strategyItem?.[strategyColumns.PRIMARY_CATEGORY] }}
          </p>
          @if (isCustom) {
            <span class="custom-badge">Custom</span>
          }
          <div class="tags-list">
            @for (tag of getTags(strategyItem); track tag) {
              <p class="tag">{{ tag }}</p>
            }
          </div>
        </div>
      </div>
      <div class="strategy-content">
        <div class="strategy-body">
          <div class="preview component">
            <h4>Preview</h4>
            @if (isCustom && strategyItem?.[strategyColumns.LINK_TO_SLIDE]) {
              <img
                class="custom-preview-image"
                [src]="strategyItem[strategyColumns.LINK_TO_SLIDE]"
                alt="Strategy preview" />
            } @else if (strategyItem?.[strategyColumns.LINK_TO_SLIDE]) {
              <strategy-embed-link [src]="strategyItem?.[strategyColumns.LINK_TO_SLIDE]"></strategy-embed-link>
            } @else {
              <h6>No preview found for this strategy</h6>
            }
          </div>
          <div class="concept component">
            <h4>Hypothesis</h4>
            <p>{{ strategyItem?.[strategyColumns.CONCEPT] }}</p>
          </div>
          <div class="comments-wrapper component">
            <strategy-comments [strategyId]="strategyId"></strategy-comments>
          </div>
        </div>
        <div class="strategy-sidebar">
          <div class="strategy-details component">
            <h4>Details</h4>
            <div class="kpi">
              <p class="title-text-grey">Main KPIs:</p>
              <div class="kpi-list">
                @for (kpi of strategyItem.parsedKpiTargets; track kpi) {
                  <p>{{ kpi }}</p>
                }
              </div>
            </div>
            <pdq-divider></pdq-divider>
            <div class="tags">
              <p class="title-text-black">Tags</p>
              <div class="tags-list">
                @if (strategyItem?.[strategyColumns.SECONDARY_CATEGORY]) {
                  <p class="tag">{{ strategyItem[strategyColumns.SECONDARY_CATEGORY] }}</p>
                }
                @for (tag of getTags(strategyItem); track tag) {
                  <p class="tag">{{ tag }}</p>
                }
              </div>
            </div>
          </div>
          <div class="connect-test-wrapper component">
            <connect-test
              [strategyId]="strategyId"
              [strategyName]="strategyItem?.[strategyColumns.NAME]"
              [isBookmarked]="isBookmarked"
              (bookmarkChanged)="onBookmarkChanged($event)"></connect-test>
            @if (isCustom) {
              <pdq-button
                class="delete-custom-strategy-btn"
                icon="trash"
                label="Delete Custom Strategy"
                variant="tertiary"
                size="small"
                [fullWidth]="true"
                [disabled]="deleting"
                [loading]="deleting"
                (onClick)="deleteCustomStrategy()">
              </pdq-button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
